import { PaginationConfig } from '@spartacus/storefront';

export const customPaginationConfig: PaginationConfig = {
  pagination: {
    previousLabel: '‹',
    nextLabel: '›',
    addStart: false,
    addEnd: false,
    addPrevious: true,
    addNext: true,
    rangeCount: 1,
    addDots: true,
    addFirst: true,
    addLast: true,
  },
};
